import { FC } from "react";
import { Globe } from "lucide-react";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { clsxMerge } from "shared/lib/helpers";

import { WIDGETS } from "@/constants/widgets";
import { widgets } from "@/widgets/index";

const openSalesFloorWidget = () => {
  widgets.open({
    id: WIDGETS.SALES_FLOORS,
  });
};

export const SalesFloorNavButton: FC<PropsWithClassNameI> = ({ className }) => {
  return (
    <label
      title="Open sales floors"
      tabIndex={10}
      className={clsxMerge(
        "group btn btn-ghost relative px-3 py-2 text-white opacity-80",
        "hover:border-[#F88167]/50 hover:bg-[#F88167]/20 hover:opacity-100",
        className
      )}
      onClick={openSalesFloorWidget}
    >
      <Globe size={24} />
    </label>
  );
};
